import React from 'react'

export default function AboutStay() {
  return (
    <>
    <section className="aboutpage-stay">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-7 col-md-6 order-2 order-lg-1 order-md-1">
                    <img src="/image/about-staying.webp" className="img-responsive" alt="About" loading="lazy"/>
                </div>

                <div className="col-lg-5 col-md-6 order-1 order-lg-2 order-md-2">
                    <div className="aboutstay-detail wow animate__animated animate__slideInUp" data-wow-delay="0.1s" data-wow-duration="1.1s" >
                        <h1 className='heading'>The Heart Behind the Name: De Coração</h1>
                        <span>…a promise kept. An invitation to experience life from the heart.</span>
                        <p>The name 'De Coração' (Portuguese for "From the Heart") was chosen by our founder to honor a legacy of genuine warmth. It reflects the Portuguese soul of our flagship Goa roots while setting a standard for our retreats in the mountains and jungles. We believe that hospitality isn't a service—it’s an emotion. Every stone laid, every spice blended, and every smile shared across our three destinations is a gift from our heart to yours, designed to transport you to a world of understated luxury where you aren't just a guest, but part of a story.</p>
                    </div>
                </div>

            </div>
        </div>
    </section> 
    </>
  )
}
